import memoizeOne from 'memoize-one';
import type { SceneData } from '@types';
import { getMediaUrl, getUrlByMediaType } from '@utils/urlMakers';

export const getRotateMediaUrl = memoizeOne(
  (sceneData: SceneData): { url?: string; type?: 'video' | 'audio' } => {
    const { voice, video: videoList = [] } = sceneData;
    if (!voice.mediaUrl && !videoList.length) return {};
    const type = voice.mediaUrl ? 'audio' : 'video';
    const url =
      type === 'audio'
        ? getUrlByMediaType(voice.type!, voice.mediaUrl)
        : getMediaUrl(videoList[0].mediaUrl);
    return { url, type };
  },
  (argsA: [SceneData], argsB: [SceneData]) => {
    const a = argsA[0];
    const b = argsB[0];
    return (
      a.voice.mediaUrl === b.voice.mediaUrl &&
      a.video[0]?.mediaUrl === b.video[0]?.mediaUrl
    );
  }
);
